import React from "react"
import { useTranslation } from "react-i18next"
import { Outlet, useMatch } from "react-router-dom"

import NavFooter from "../../components/NavFooter/NavFooter"
import { getSelectedModel } from "../../hooks/use-selected-model"
import useSiteTitle from "../../hooks/use-site-title"
import Footer from "../Footer/Footer"
import Header from "../Header/Header"

import configurationStyles from "../ConfiguratorLayout/ConfiguratorLayout.module.scss"
import styles from "./GeneralLayout.module.scss"

const GeneralLayout = () => {
  const { i18n } = useTranslation()
  const home = useMatch("/" + i18n.language)
  const homeConfigure = useMatch("/" + i18n.language + "/configure")

  const legalMatch = useMatch(`/${i18n.language}/:page`);
  const isLegalPage =
  legalMatch &&
  ["cookies-policy", "privacy-policy", "terms-of-use"].includes(legalMatch.params.page);

  const model = getSelectedModel()
  const summaryPage = useMatch(
    "/" + i18n.language + "/configure/" + model + "/summary"
  )
  return (
    <div className={styles.content}>
      {/* Main header */}
      <Header
        data={{
          titulo: useSiteTitle(),
        }}
      />

      {/* Main content */}
      <main className={!summaryPage ? styles.main : configurationStyles.main}>
        <div
          className={
            !summaryPage ? styles.container : configurationStyles.container
          }
        >
          <Outlet />
        </div>
      </main>

      {/* Site footer */}
      {home !== null || homeConfigure !== null || isLegalPage !== null ? (
        <Footer areaB={<NavFooter />} />
      ) : (
        ""
      )}
    </div>
  )
}

export default GeneralLayout
